import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/banner2.webp")